/*
 * 复制自 src/pages/photo/OpenEnterprise.tsx，用于 photov2，避免跨目录依赖
 */
import React, { useMemo } from 'react'
import lock from '../../../images/photo_lock.png'
import Photo from '../../components/Photo'
import viewLimitSample1 from '../../../images/view_limit_sample_1.jpg'
import viewLimitSample2 from '../../../images/view_limit_sample_2.jpg'
import viewLimitSample3 from '../../../images/view_limit_sample_3.jpg'
import qiweiQrcode from '../../../images/qiwei_qrcode.png'
import { useAppSelector } from '../../../app/hooks'

const viewLimitSample = [viewLimitSample1, viewLimitSample2, viewLimitSample3]

interface OpenEnterpriseProps {
  columnCount: number
}

const OpenEnterprise: React.FC<OpenEnterpriseProps> = ({ columnCount }) => {
  const kvConfig = useAppSelector((state) => state.main.config)

  const samplePhotos = useMemo(() => {
    return Array.from({ length: columnCount }).map((_, index) => {
      return {
        smallURL:
          viewLimitSample[Math.floor(Math.random() * viewLimitSample.length)],
        canCheck: false,
        readyToCheck: false,
        onPreview: () => {
          /* 示例图不可预览 */
        }
      }
    })
  }, [columnCount])

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      {samplePhotos.map((photo, index) => (
        <div key={index} style={{ width: '238px', height: '280px' }}>
          <Photo
            checked={false}
            style={{ margin: 0, filter: 'blur(8px)' }}
            photo={photo}
            canCheck={false}
            readyToCheck={false}
            onPreview={() => {
              /* 示例图不可预览 */
            }}
          />
        </div>
      ))}
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 11,
          whiteSpace: 'nowrap',
          fontWeight: 'bold',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          display: 'flex',
          justifyContent: 'center',
          paddingTop: '20px'
        }}
      >
        <img
          src={qiweiQrcode}
          alt="qiweiQrcode"
          style={{ width: '170px', height: '170px' }}
        />
        <div
          style={{
            marginTop: '10px',
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
          }}
        >
          <img
            src={lock}
            alt="lock"
            style={{ width: '19px', height: '23px' }}
          />
          <div
            style={{ fontSize: '20px', color: '#9A6516', marginTop: '10px' }}
          >
            团队人数已超上限，请联系商务人员开通企业版
            <p style={{ color: '#D25F00' }}>
              电话：{kvConfig.team_member_oversize_call_Phone || '13699662891'}
            </p>
          </div>
          <div
            style={{ fontSize: '20px', color: '#9A6516', marginTop: '16px' }}
          >
            <p>也可扫码添加【专属企微客服】</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OpenEnterprise
